import * as actions from '../_actions/types';

const initailState = {
  u_id: '',
  isLogin: false,
};

export default function (state = initailState, action) {
  switch (action.type) {
    case actions.LOGIN_USER:
      return {
        ...state,
        u_id: action.payload.u_id,
        isLogin: action.payload.isLogin,
      };
    case actions.LOGOUT_USER:
      return {
        ...state,
        u_id: '',
        isLogin: false,
      };
    case actions.LOGIN_CHECK:
      return {
        ...state,
        isLogin: true,
      };
    default:
      return state;
  }
}
